import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { BulkUpdateChanges } from '../../models/bulk.update.reset.interface';
import { PriceAdjustmentTypes_Enum } from '../../enums/price-adjustment-types.enum';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-bulk-update-rollback',
  templateUrl: './bulk-update-rollback.component.html',
  styleUrls: ['./bulk-update-rollback.component.scss']
})
export class BulkUpdateRollbackComponent implements AfterViewInit, OnInit, OnDestroy {

  dataSource = new MatTableDataSource<BulkUpdateChanges>();
  displayedColumns: string[] =
    ['details', 'bulkChangeType_Desc', 'bulkChange_AdjustmentAmount', 'bulkChange_Created', 'changedBy', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  bulkUpdates: BulkUpdateChanges[];
  priceAdjustmentEnum = PriceAdjustmentTypes_Enum;
  errors: string;

  constructor(private adminService: AdminService, public itemRollbackDialogRef: MatDialogRef<BulkUpdateRollbackComponent>, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    let dealerId = this.adminService.getDealerId();
    this.adminService.getBulkChanges(dealerId)
      .subscribe({
        next: (data) => {
          this.bulkUpdates = data;

          this.dataSource.data = this.bulkUpdates;
        }
      });
  }

  rollbackPriceChange(bulkChangeId: number) {
    this.errors = '';
    console.log("reverse bulk update for" + bulkChangeId);

    this.adminService.rollbackBulkChange(bulkChangeId)
      .subscribe({
        next: (result) => {
          console.log('items Updated from bulk update = ' + result);
          this.snackBar.open("Item pricing rolled back for " + result + " items.", null, { duration: 2000, verticalPosition: 'bottom', panelClass: ['bidit-snackbar'] });

          //this.itemRollbackDialogRef.close();
        },
        error: (error: string) => {
          this.errors = error;
        }
      });
  };

  onNoClick(): void {
    this.itemRollbackDialogRef.close();
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

}
